import classNames from "classnames";
import { type HTMLAttributes } from "react";

type DotProps = {
  size?: "sm" | "md" | "lg";
  color:
    | "primary"
    | "success"
    | "error"
    | "gray"
    | "grayBlue"
    | "blueLight"
    | "blue"
    | "blueDark"
    | "indigo"
    | "purple"
    | "pink"
    | "orange"
    | "warning"
    | "modern";
} & HTMLAttributes<HTMLDivElement>;

export default function Dot({
  size = "sm",
  color = "primary",
  className,
}: DotProps) {
  const sizes = {
    sm: "h-2 w-2",
    md: "h-2.5 w-2.5",
    lg: "h-3 w-3",
  };

  const colors = {
    primary: "bg-primary-500",
    success: "bg-success-500",
    error: "bg-error-500",
    gray: "bg-gray-500",
    grayBlue: "bg-grayblue-500",
    blueLight: "bg-bluelight-500",
    blue: "bg-blue-500",
    blueDark: "bg-bluedark-500",
    indigo: "bg-indigo-500",
    purple: "bg-purple-500",
    pink: "bg-pink-500",
    orange: "bg-orange-500",
    warning: "bg-warning-500",
    modern: "",
  };

  return (
    <span
      className={classNames(
        "inline-block rounded-full",
        className,
        sizes[size],
        colors[color],
      )}
    />
  );
}
